class MobileAppPreview {
  constructor (element) {
    this.element = element;
    this.turboFrame = this.element.querySelector('.apppreview__turboframe');
    this.resetEl = this.element.querySelector('.apppreview__reset');
    this.reloadSrc = this.turboFrame.getAttribute('data-reload-src');
    this.tryMeEl = this.element.querySelector('.apppreview__tryme');

    if( null !== this.turboFrame && null !== this.resetEl && null !== this.tryMeEl ) {
      this.init();
    }
  }

  init() {
    // fires after the form submission-initiated network request completes.
    this.turboFrame.addEventListener('turbo:submit-end', (event) => {
      if (event.detail.success) {
        let responseURL = event.detail.formSubmission.result.fetchResponse.response.url;
        let responseURLSlug = responseURL.substring(responseURL.lastIndexOf('/') + 1);

        if (this.isValidResponce(event.detail)) {
          this.showConfirmation(responseURLSlug);
        } else {
          this.hideConfirmation();
        }
      } else {
        this.hideConfirmation();
      }
    });

    this.resetEl.addEventListener('click', () => this.reloadTurbo());

    this.tryMeEl.addEventListener('click', () => this.hideTryMe());
  }

  isValidResponce(details) {
    let locationHref = details.formSubmission.location.href;
    let detailsResponceUrl = details.fetchResponse.response.url;

    if (locationHref === detailsResponceUrl) {
      // initial form state returned
      // we might got a `videos not found` error
      return false;
    } else {
      return true;
    }
  }

  hideTryMe() {
    this.tryMeEl.classList.add('opacity-0');
    setTimeout(() => {
      this.tryMeEl.classList.remove('opacity-1');
      this.tryMeEl.classList.add('hidden');
    }, 300);
  }

  showTryMe() {
    this.tryMeEl.classList.remove('hidden');
    this.tryMeEl.classList.add('opacity-1');
    setTimeout(() => {
      this.tryMeEl.classList.remove(
        'opacity-0',
      );
    }, 300);
  }

  reloadTurbo() {
    this.turboFrame.setAttribute('src', this.reloadSrc);
    this.turboFrame.reload();
    this.hideConfirmation();
  }

  showConfirmation(slug) {
    let url = new URL(location);
    url.searchParams.set('app_preview', slug);
    history.pushState({}, '', url);

    this.element.classList.add('apppreview__confirmation--show');
    this.showTryMe();
  }

  hideConfirmation() {
    let url = new URL(location);
    url.searchParams.delete('app_preview');
    history.pushState({}, '', url);

    this.element.classList.remove('apppreview__confirmation--show');
    this.hideTryMe();
  }
}

export default function() {
  let appPreviews = document.querySelectorAll('.apppreview');
  appPreviews.forEach(el => {
    new MobileAppPreview(el);
  });
}
